import { type QueryClient } from '@tanstack/react-query';
import { StatusCode, getPreferenceOptions } from '@hungryroot/rest';

export const getPreferenceOptionsQueryKey = () => ['preference_options'];

const timeLimit = 5 * 60 * 1000;

export async function fetchPreferenceOptions() {
  const resp = await getPreferenceOptions();

  if (resp.status !== StatusCode.SuccessOK) {
    throw new Error(JSON.stringify(resp.data, null, 2));
  }

  return resp.data;
}

export function prefetchPreferenceOptions(queryClient: QueryClient) {
  return queryClient.prefetchQuery({
    queryKey: getPreferenceOptionsQueryKey(),
    queryFn: fetchPreferenceOptions,
    staleTime: timeLimit,
  });
}
